
import { Button, Row, Col } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react"
import StandardModal from './defaultModals/StandardModal';
import { Content as TandC } from 'components/TandC/Content';
import { useNavigationAction } from 'components/navigation/NavigationContext';

export default function Footer() {

  const currentYear = new Date().getFullYear();
  const url = process.env.REACT_APP_URL;

  const [club, setClub] = useState([]);
  const [emails, setEmails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', body: '' });
  const socialLinks = [
    { key: 'linkedIn', label: 'LinkedIn', icon: 'bi-linkedin' },
    { key: 'facebook', label: 'Facebook', icon: 'bi-facebook' },
    { key: 'instagram', label: 'Instagram', icon: 'bi-instagram' },
    { key: 'x', label: 'X', icon: 'bi-twitter-x' },
    { key: 'youtube', label: 'YouTube', icon: 'bi-youtube' },
  ].filter(({ key }) => club?.[`${key}Visible`] && club?.[key]);

  const getClub = useCallback(async () => {
    try {
      const response = await fetch(`${url}/club`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const [data] = await response.json(); // Assuming the API returns an array
        setClub(data);
      } else {
        console.error("Error fetching club data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching club data:", error);
    }
  }, [url]);

  const getEmails = useCallback(async () => {
    try {
      const response = await fetch(`${url}/front`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        setEmails(data[0].contact?.to);
      } else {
        console.error("Error fetching emails:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching emails:", error);
    }
  }, [url]);

  useEffect(() => {
    getClub(); // Fetch club data on component mount
    getEmails();
  }, [getClub, getEmails]);


  const handleShowTandCModal = () => {
    setModalContent({
      title: 'Terms and Conditions',
      ModalBodyComponent: <TandC />
    });
    setShowModal(true);
  }

  useNavigationAction('about', {
    label: 'About & Contact',
    icon: 'bi-info-circle',
    renderContent: () => (
      <div className="footer-about-links">
        {socialLinks.map(({ key, label, icon }) => (
          <a key={key} href={club[key]} target="_blank" rel="noreferrer">
            <i className={`bi ${icon}`} aria-hidden="true" /><span>{label}</span>
          </a>
        ))}
        {Array.isArray(emails) && emails.length > 0 && (
          <a href={`mailto:${emails.join(',')}?subject=${encodeURIComponent('Toastmasters club contact')}`}>
            <i className="bi bi-envelope" aria-hidden="true" /><span>Contact the club</span>
          </a>
        )}
        <button type="button" onClick={handleShowTandCModal}>
          <i className="bi bi-file-text" aria-hidden="true" /><span>Terms and Conditions</span>
        </button>
      </div>
    ),
  });

  return (
    <footer className="tm-footer">
      <Row>
        {club &&
          <Col className="tm-footer-left social" xs={12} md={6} xl={6}>
            {club?.linkedInVisible && <a href={club?.linkedIn ? club?.linkedIn : ''} target="_blank" rel="noreferrer"><i className="bi bi-linkedin" /></a>}
            {club?.facebookVisible && <a href={club?.facebook ? club?.facebook : ''} target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a>}
            {club?.instagramVisible && <a href={club?.instagram ? club?.instagram : ''} target="_blank" rel="noreferrer"><i className="bi bi-instagram" /></a>}
            {club?.xVisible && <a href={club?.x ? club?.x : ''} target="_blank" rel="noreferrer"><i className="bi bi-twitter-x" /></a>}
            {club?.youtubeVisible && <a href={club?.youtube ? club?.youtube : ''} target="_blank" rel="noreferrer"><i className="bi bi-youtube" /></a>}
            {Array.isArray(emails) && emails.length > 0 && (
              <a
                href={`mailto:${emails.join(',')}?subject=${encodeURIComponent('Toastmasters club contact')}`}
                target="_blank" rel="noreferrer"
              >
                <i className="bi bi-envelope" />
              </a>
            )}
          </Col>
        }
        <Col className="tm-footer-right" xs={12} md={6} xl={6}>
          <Button className="footer-terms" variant="link" onClick={handleShowTandCModal}>Terms and Conditions</Button>
          {/* <br /> */}
          <p className="mb-0 footer-copyright">© {currentYear} {club?.name}</p>
        </Col>
      </Row>

      <StandardModal
        navigationParent="about"
        show={showModal}
        handleClose={() => setShowModal(false)}
        title={modalContent.title}
        ModalBodyComponent={modalContent.ModalBodyComponent}
      />

    </footer>
  );
}